module.exports = __webpack_public_path__ + "img/inspiration_img_4.6704a5eb.jpg";